"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeySecurityScheme = exports.OAuth2SecurityScheme = exports.Security = void 0;
const codegen_1 = require("@azure-tools/codegen");
class Security extends codegen_1.Initializer {
    constructor(authenticationRequired, objectInitializer) {
        super();
        this.authenticationRequired = authenticationRequired;
        this.schemes = [];
        this.apply(objectInitializer);
    }
}
exports.Security = Security;
class OAuth2SecurityScheme {
    constructor(objectInitializer) {
        this.type = "OAuth2";
        Object.assign(this, objectInitializer);
    }
}
exports.OAuth2SecurityScheme = OAuth2SecurityScheme;
class KeySecurityScheme {
    constructor(objectInitializer) {
        this.type = "Key";
        Object.assign(this, objectInitializer);
    }
}
exports.KeySecurityScheme = KeySecurityScheme;
//# sourceMappingURL=security.js.map